/**
 * Native (Capacitor) Google OAuth: HTTPS callback → custom scheme ile uygulamaya dönüş.
 * Şema: dekosta://auth/callback#token=...
 */

import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

export const OAUTH_HANDOFF_QUERY = 'cap_handoff';
export const OAUTH_HANDOFF_VALUE_NATIVE = 'native';

/** Web üzerinde çalışan /auth/callback tam URL’i (Google dönüşü) */
export function buildWebAuthCallbackUrl(publicBase, withNativeHandoff) {
  const b = String(publicBase || '').replace(/\/+$/, '');
  const u = new URL(`${b}/auth/callback`);
  if (withNativeHandoff) {
    u.searchParams.set(OAUTH_HANDOFF_QUERY, OAUTH_HANDOFF_VALUE_NATIVE);
  }
  return u.toString();
}

/** Tarayıcıdan uygulamaya; hash ile (query loglarda daha görünür) */
export function buildNativeOAuthDeepLink(token) {
  const t = encodeURIComponent(token);
  return `dekosta://auth/callback#token=${t}`;
}

/**
 * appUrlOpen / getLaunchUrl ile gelen URL’den JWT çıkar.
 */
export function parseTokenFromOAuthDeepLink(rawUrl) {
  if (!rawUrl || typeof rawUrl !== 'string') return null;
  if (!rawUrl.toLowerCase().startsWith('dekosta://')) return null;

  const hashIdx = rawUrl.indexOf('#');
  if (hashIdx >= 0) {
    const fragment = rawUrl.slice(hashIdx + 1);
    const p = new URLSearchParams(fragment);
    const t = p.get('token');
    if (t) return decodeURIComponent(t);
  }

  const qIdx = rawUrl.indexOf('?');
  if (qIdx >= 0) {
    const query = rawUrl.slice(qIdx + 1).split('#')[0];
    const p = new URLSearchParams(query);
    const t = p.get('token');
    if (t) return t;
  }

  return null;
}

export function isNativeHandoffRequest(searchString) {
  try {
    const p = new URLSearchParams(searchString.startsWith('?') ? searchString.slice(1) : searchString);
    return p.get(OAUTH_HANDOFF_QUERY) === OAUTH_HANDOFF_VALUE_NATIVE;
  } catch {
    return false;
  }
}

/** Native: Custom Tab (Browser.open). Web: tam sayfa yönlendirme. */
export async function startGoogleOAuthNavigation(authUrl) {
  if (Capacitor.isNativePlatform()) {
    try {
      await Browser.open({ url: authUrl });
      return;
    } catch (e) {
      console.warn('[oauth] Browser.open failed, fallback', e);
    }
  }
  window.location.href = authUrl;
}

/** Browser.open ile açılan OAuth sekmesini kapatır; hata olsa bile auth akışını bozmaz. */
export async function closeInAppOAuthBrowser() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await Browser.close();
  } catch (e) {
    console.warn('[oauth] Browser.close failed', e);
  }
}
